import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const pathMap: Record<string, string> = {
  'dashboard': 'Dashboard',
  'kubernetes': 'Kubernetes',
  'explorer': 'Explorer',
  'pods': 'Pods',
  'clusters': 'Clusters',
  'namespaces': 'Namespaces',
  'services': 'Services',
  'details': 'Details',
};

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  return (
    <nav className="text-sm mb-4" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        <li>
          <Link to="/" className="text-primary-600 hover:underline">Home</Link>
        </li>
        {pathnames.map((value, idx) => {
          const to = '/' + pathnames.slice(0, idx + 1).join('/');
          const isLast = idx === pathnames.length - 1;
          const label = pathMap[value] || value;
          return (
            <li key={to} className="flex items-center">
              <span className="mx-2 text-gray-400">/</span>
              {isLast ? (
                <span className="text-gray-700 dark:text-gray-200 font-semibold">{label}</span>
              ) : (
                <Link to={to} className="text-primary-600 hover:underline">{label}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
